import React, {PropsWithChildren, useEffect, useState} from 'react';
import {Role} from '../../interface';
import {Navigate} from 'react-router-dom';
import {useAppSelector} from '../../hook/store';
import {UserState} from '../../store/slice/user-slice';
import {RoleState} from '../../store/slice/role-slice';

interface ProtectedRouteProps extends PropsWithChildren {
}

const ProtectedRoute = ({children}: ProtectedRouteProps): any => {
    const {currentUser} = useAppSelector<UserState>(state => state.user);
    const {roleList} = useAppSelector<RoleState>(state => state.role);
    const [role, setRole] = useState<Role>();

    useEffect(() => {
        if (!!roleList && !!currentUser) {
            const role = roleList.find(r => r.id === currentUser.role);
            if (role) {
                setRole(role.name);
            }
        }
    }, [roleList, currentUser]);

    if (role) {
        if (role !== Role.ROLE_ADMIN) {
            return <Navigate replace to={'/'}/>;
        }
        return children;
    }
    return null;
};

export {ProtectedRoute};
